<template>
  <z-collapse :title="$t('forfait.invoiceTransfer')" :is-toggle="true" class="divider">
    <template v-slot:action>
      <p class="btn-blue" @click="printHandle">{{ $t('btns.print') }}</p>
    </template>
    <div class="mb_20">
      <ul v-if="applicationStatus == 102||applicationStatus == 1003" class="c-list forfait edit">
        <li class="c-textarea">
          <h3>{{ $t('invoice.noticeAssign') }}</h3>
          <el-input
            :placeholder="$t('financingAppliForm.pleaseEnText')"
            v-model="title"
            type="textarea"
            maxlength="1000"/>
        </li><!--      Notice of Assignment-->
        <li><span class="tit">{{ $t('invoice.transactionDate') }}</span>
          <div class="msg">
            <el-date-picker v-model="transactionDate" :placeholder="$t('loan.selectTime')" type="date"/>
          </div>
        </li><!--      Transaction Date -->
        <li><span class="tit">{{ $t('invoice.serialNumber') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.flowNumber" disabled/>
          </div>
        </li><!--      融资流水号-->
        <li><span class="tit">{{ $t('invoice.contractNum') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.contractNum" disabled/>
          </div>
        </li><!--      合同号-->
        <li v-if="msg.finalReceiptNum"><span class="tit">{{ $t('invoice.invoiceNum') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.finalReceiptNum" disabled/>
          </div>
        </li>
        <li v-else><span class="tit">{{ $t('forfait.invoiceNum') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.invoiceNumberCoft" disabled />
          </div>
        </li><!--      发票号-->
        <li><span class="tit">{{ $t('invoice.seller') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.seller" disabled/>
          </div>
        </li><!--      卖方-->
        <li><span class="tit">{{ $t('invoice.buyer') }}</span>
          <div class="msg">
            <el-input v-model.trim="msg.buyer" disabled/>
          </div>
        </li><!--      买方-->
        <li><span class="tit">{{ $t('invoice.buyer') }}</span>
          <div class="msg">
            <el-select v-model="currency" class="w-240">
              <el-option v-for="(key,value) in currencyList" :label="value" :value="key" :key="key"/>
            </el-select>
          </div>
        </li><!--      币种-->
        <li><span class="tit">{{ $t('invoice.exchangeRate') }}</span>
          <div class="msg">
            <el-input
              v-model.trim="exchangeRate"
              clearable
              @keyup.native="exchangeRateInput()"
              @blur="numberBlur('exchangeRate',4)"/>
          </div>
        </li><!--      汇率-->
        <li><span class="tit">{{ $t('invoice.contractAmount') }}</span>
          <div class="msg cols">
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="exportContractAmount"
                :maxlength="17"
                clearable
                @blur="numberBlur('exportContractAmount',2)"
                @keyup.native="exportContractAmountInput()">
                <template slot="prepend">{{ currency }}</template>
              </el-input>
            </div>
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="exportContractAmountFinal"
                clearable
                maxlength="17"
                @blur="numberBlur('exportContractAmountFinal',2)"
                @keyup.native="moneyInput('exportContractAmountFinal')">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div><!-- USD 汇率计算金额 -->
            <div class="w-240"/>
          </div>
        </li><!--      出口金额-->

        <li><span class="tit">{{ $t('invoice.invoiceAmount') }}</span>
          <div class="msg cols">
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="assignedInvoiceAmount"
                :maxlength="17"
                clearable
                @blur="numberBlur('assignedInvoiceAmount',2)"
                @keyup.native="assignedInvoiceAmountInput()">
                <template slot="prepend">{{ currency }}</template>
              </el-input>
            </div>
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="assignedInvoiceAmountFinal"
                clearable
                maxlength="17"
                @blur="numberBlur('assignedInvoiceAmountFinal',2)"
                @keyup.native="moneyInput('assignedInvoiceAmountFinal')">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div> <!-- USD 汇率计算金额 -->
            <div class="w-240"/>
          </div>
        </li><!--      指定的发票金额-->

        <li><span class="tit">{{ $t('invoice.purchaseAmount') }}</span>
          <div class="msg cols">
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="zmaPurchaseAmount"
                :maxlength="17"
                clearable
                @blur="numberBlur('zmaPurchaseAmount',2)"
                @keyup.native="zmaPurchaseAmountInput()">
                <template slot="prepend">{{ currency }}</template>
              </el-input>
            </div>
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="zmaPurchaseAmountFinal"
                clearable
                maxlength="17"
                @blur="numberBlur('zmaPurchaseAmountFinal',2)"
                @keyup.native="moneyInput('zmaPurchaseAmountFinal')">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div> <!-- USD 汇率计算金额 -->
            <div class="w-240"/>
          </div>
        </li><!--      zma购买金额-->

        <li><span class="tit">{{ $t('invoice.agentFee') }}</span>
          <div class="msg cols">
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="collectionAgentFee"
                :maxlength="17"
                clearable
                @blur="numberBlur('collectionAgentFee',2)"
                @keyup.native="collectionAgentFeeInput()">
                <template slot="prepend">{{ currency }}</template>
              </el-input>
            </div>
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="collectionAgentFeeFinal"
                clearable
                maxlength="17"
                @blur="numberBlur('collectionAgentFeeFinal',2)"
                @keyup.native="moneyInput('collectionAgentFeeFinal',1)">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div> <!-- USD 汇率计算金额 -->
            <div class="w-240"/>
          </div>
        </li><!--      cic收取的代理费-->

        <li><span class="tit">{{ $t('invoice.paymentAmount') }}</span>
          <div class="msg cols">
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="cicPayAmount"
                :maxlength="17"
                clearable
                @blur="numberBlur('cicPayAmount',2)"
                @keyup.native="cicPayAmountInput()">
                <template slot="prepend">{{ currency }}</template>
              </el-input>
            </div>
            <div class="w-240">
              <el-input
                :placeholder="$t('financingAppliForm.pleaseEnText')"
                v-model.trim="cicPayAmountFinal"
                clearable
                maxlength="17"
                @blur="numberBlur('cicPayAmountFinal',2)"
                @keyup.native="moneyInput('cicPayAmountFinal')">
                <template slot="prepend">{{ defaultCurrency }}</template>
              </el-input>
            </div> <!-- USD 汇率计算金额 -->
            <div class="w-240"/>
          </div>
        </li><!--      cic给zma支付的费用-->

        <li><span class="tit">{{ $t('invoice.paymentDate') }}</span><div class="msg">
          <el-date-picker v-model="cicPayDate" :placeholder="$t('loan.selectTime')" type="date"/>
        </div></li><!--      cic给zma支付的时间-->

        <li><span class="tit">{{ $t('invoice.discountRate') }}</span><div class="msg">
          <el-input
            :placeholder="$t('financingAppliForm.pleaseEnText')"
            v-model.trim="zmaDiscountRate"
            clearable
            maxlength="17"
            @blur="numberBlur('zmaDiscountRate',3)"
            @keyup.native="rateInput('zmaDiscountRate')">
            <template slot="append">%</template>
          </el-input>
        </div></li><!--      zma的净贴现率-->

        <li><span class="tit">{{ $t('invoice.transactionMargin') }}</span><div class="msg">
          <el-input
            :placeholder="$t('financingAppliForm.pleaseEnText')"
            v-model.trim="zmaTransactionMargin"
            class="w-240"
            clearable
            maxlength="17"
            @blur="numberBlur('zmaTransactionMargin',2)"
            @keyup.native="moneyInput('zmaTransactionMargin')">
            <template slot="prepend">{{ defaultCurrency }}</template>
          </el-input>
        </div></li><!--      zma交易保证金-->

        <li class="c-textarea">
          <el-input
            :placeholder="$t('financingAppliForm.pleaseEnText')"
            v-model="affimBankInfo"
            type="textarea"
            maxlength="1000"/>
        </li>
        <li class="c-textarea">
          <el-input
            :placeholder="$t('financingAppliForm.pleaseEnText')"
            v-model="bankInfo"
            type="textarea"
            maxlength="1000"/>
        </li>
      </ul>

      <div v-if="applicationStatus !== 102&&applicationStatus !== 1003" class="invoice-msg">
        <div class="m-tit">
          <h3>{{ $t('invoice.noticeAssign') }}</h3>
          <p class="text-pre" v-html="msg.title"/>
        </div>
        <ul class="c-list forfait">
          <li><span class="tit">{{ $t('invoice.transactionDate') }}</span><div class="msg">{{ msg.transactionDate | dateConvert }}</div></li>
          <li><span class="tit">{{ $t('invoice.serialNumber') }}</span><div class="msg">{{ msg.flowNumber }}</div></li>
          <!--      融资流水号-->
          <li><span class="tit">{{ $t('invoice.contractNum') }}</span><div class="msg">{{ msg.contractNum }}</div></li>
          <!--      合同号-->
          <li><span class="tit">{{ $t('invoice.invoiceNum') }}</span><div class="msg">{{ msg.finalReceiptNum ||msg.invoiceNumberCoft }}</div></li>
          <!--      发票号-->
          <li><span class="tit">{{ $t('invoice.seller') }}</span><div class="msg">{{ msg.seller }}</div></li>
          <!--      卖方-->
          <li><span class="tit">{{ $t('invoice.buyer') }}</span><div class="msg">{{ msg.buyer }}</div></li>
          <!--      买方-->
          <li><span class="tit">{{ $t('invoice.currency') }}</span><div class="msg">{{ msg.currency }}</div></li>
          <!--      币种-->
          <li><span class="tit">{{ $t('invoice.exchangeRate') }}</span><div class="msg">{{ msg.exchangeRate }}</div></li>
          <!--      汇率-->
          <li><span class="tit">{{ $t('invoice.contractAmount') }}</span><div class="msg cols2">
            <div class="w-300">{{ msg.currency }} {{ msg.exportContractAmount | formatNum(2) }}</div>
            <div class="w-300">{{ defaultCurrency }} {{ msg.exportContractAmountFinal | formatNum(2) }}</div>
          </div></li>
          <!--      出口金额-->

          <li><span class="tit">{{ $t('invoice.invoiceAmount') }}</span><div class="msg cols2">
            <div class="w-300">{{ msg.currency }} {{ msg.assignedInvoiceAmount | formatNum(2) }}</div>
            <div class="w-300">{{ defaultCurrency }} {{ msg.assignedInvoiceAmountFinal | formatNum(2) }}</div>
          </div></li>
          <!--      指定的发票金额-->

          <li><span class="tit">{{ $t('invoice.purchaseAmount') }}</span><div class="msg cols2">
            <div class="w-300">{{ msg.currency }} {{ msg.zmaPurchaseAmount | formatNum(2) }}</div>
            <div class="w-300">{{ defaultCurrency }} {{ msg.zmaPurchaseAmountFinal | formatNum(2) }}</div>
          </div></li>
          <!--      zma购买金额-->

          <li><span class="tit">{{ $t('invoice.agentFee') }}</span><div class="msg cols2">
            <div class="w-300">{{ msg.currency }} {{ msg.collectionAgentFee | formatNum(2) }}</div>
            <div class="w-300">{{ defaultCurrency }} {{ msg.collectionAgentFeeFinal | formatNum(2) }}</div>
          </div></li>
          <!--      cic收取的代理费-->

          <li><span class="tit">{{ $t('invoice.paymentAmount') }}</span><div class="msg cols2">
            <div class="w-300">{{ msg.currency }} {{ msg.cicPayAmount | formatNum(2) }}</div>
            <div class="w-300">{{ defaultCurrency }} {{ msg.cicPayAmountFinal | formatNum(2) }}</div>
          </div></li>
          <!--      cic给zma支付的费用-->

          <li><span class="tit">{{ $t('invoice.paymentDate') }}</span><div class="msg">{{ msg.cicPayDate | dateConvert }}</div></li>
          <!--      cic给zma支付的时间-->

          <li><span class="tit">{{ $t('invoice.discountRate') }}</span><div class="msg">{{ msg.zmaDiscountRate | formatNum(3) }}%</div></li>
          <!--      zma的净贴现率-->
          <li><span class="tit">{{ $t('invoice.transactionMargin') }}</span><div class="msg">{{ defaultCurrency }} {{ msg.zmaTransactionMargin | formatNum(2) }}</div></li>
          <!--      zma交易保证金-->
        </ul>
        <div v-if="msg.affimBankInfo" class="m-tit">
          <p class="text-pre" v-html="msg.affimBankInfo"/>
        </div>
        <!--    确认银行消息-->

        <div v-if="msg.bankInfo" class="m-tit">
          <p class="text-pre pb-15" v-html="msg.bankInfo"/>
        </div> <!--    银行信息-->

        <ul v-if="msg.cicFsCtbFileVOS && msg.cicFsCtbFileVOS.length >0&&applicationStatus!=1008&&applicationStatus!=112" class="c-list border forfait">
          <li>
            <span class="tit">{{ $t('loan.fileUpload') }}</span>
            <div class="msg c-file-list"><a v-for="(fileObj,fileIndex) in msg.cicFsCtbFileVOS" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)"><i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}</a></div>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="printVisible" width="100%" custom-class="dialogPrint">
      <div ref="printContract" class="print-msg line">
        <div class="header" style="padding: 30px 0 20px;">
          <img width="300" src="@/assets/images/cic.png" alt="">
        </div>
        <div class="m-tit">
          <h3>{{ $t('invoice.noticeAssign') }}</h3>
        </div>
        <div v-if="msg.title" class="c-msg">
          <p class="text-pre" v-html="msg.title"/>
        </div>
        <ul class="c-list" style="margin: -1px 0 0;">
          <li><span class="tit">{{ $t('invoice.transactionDate') }}</span><div class="msg">{{ msg.transactionDateVoice || msg.transactionDate | dateConvert }}</div></li>
          <li><span class="tit">{{ $t('invoice.serialNumber') }}</span><div class="msg">{{ msg.flowNumber }}</div></li>
          <!--      融资流水号-->
          <li><span class="tit">{{ $t('invoice.contractNum') }}</span><div class="msg">{{ msg.contractNum }}</div></li>
          <!--      合同号-->
          <li><span class="tit">{{ $t('invoice.invoiceNum') }}</span><div class="msg">{{ msg.finalReceiptNum||msg.invoiceNumberCoft }}</div></li>
          <!--      发票号-->
          <li><span class="tit">{{ $t('invoice.seller') }}</span><div class="msg">{{ msg.seller }}</div></li>
          <!--      卖方-->
          <li><span class="tit">{{ $t('invoice.buyer') }}</span><div class="msg">{{ msg.buyer }}</div></li>
          <!--      买方-->
          <li><span class="tit">{{ $t('invoice.currency') }}</span><div class="msg">{{ msg.currencyVoice || msg.currency }}</div></li>
          <!--      币种-->
          <li><span class="tit">{{ $t('invoice.exchangeRate') }}</span><div class="msg">{{ msg.exchangeRateVoice || msg.exchangeRate }}</div></li>
          <!--      汇率-->
          <li><span class="tit">{{ $t('invoice.contractAmount') }}</span><div class="msg cols2">
            <span class="span-1">{{ msg.currencyVoice || msg.currency }}</span>
            <span class="span-5">{{ msg.exportContractAmount | formatNum(2) }}</span>
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-5">{{ msg.exportContractAmountFinal | formatNum(2) }}</span>
          </div></li>
          <!--      出口金额-->

          <li><span class="tit">{{ $t('invoice.invoiceAmount') }}</span><div class="msg cols2">
            <span class="span-1">{{ msg.currencyVoice || msg.currency }}</span>
            <span class="span-5">{{ msg.assignedInvoiceAmount | formatNum(2) }}</span>
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-5">{{ msg.assignedInvoiceAmountFinal | formatNum(2) }}</span>
          </div></li>
          <!--      指定的发票金额-->

          <li><span class="tit">{{ $t('invoice.purchaseAmount') }}</span><div class="msg cols2">
            <span class="span-1">{{ msg.currencyVoice || msg.currency }}</span>
            <span class="span-5">{{ msg.zmaPurchaseAmount | formatNum(2) }}</span>
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-5">{{ msg.zmaPurchaseAmountFinal | formatNum(2) }}</span>
          </div></li>
          <!--      zma购买金额-->

          <li><span class="tit">{{ $t('invoice.agentFee') }}</span><div class="msg cols2">
            <span class="span-1">{{ msg.currencyVoice || msg.currency }}</span>
            <span class="span-5">{{ msg.collectionAgentFee | formatNum(2) }}</span>
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-5">{{ msg.collectionAgentFeeFinal | formatNum(2) }}</span>
          </div></li>
          <!--      cic收取的代理费-->

          <li><span class="tit">{{ $t('invoice.paymentAmount') }}</span><div class="msg cols2">
            <span class="span-1">{{ msg.currencyVoice || msg.currency }}</span>
            <span class="span-5">{{ msg.cicPayAmount | formatNum(2) }}</span>
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-5">{{ msg.cicPayAmountFinal | formatNum(2) }}</span>
          </div></li>
          <!--      cic给zma支付的费用-->

          <li><span class="tit">{{ $t('invoice.paymentDate') }}</span><div class="msg">{{ msg.cicPayDateVoice || msg.cicPayDate | dateConvert }}</div></li>
          <!--      cic给zma支付的时间-->

          <li><span class="tit">{{ $t('invoice.discountRate') }}</span><div class="msg">{{ msg.zmaDiscountRate | formatNum(3) }}%</div></li>
          <!--      zma的净贴现率-->
          <li><span class="tit">{{ $t('invoice.transactionMargin') }}</span><div class="msg cols2">
            <span class="span-1">{{ defaultCurrency }}</span>
            <span class="span-0">{{ msg.zmaTransactionMargin | formatNum(2) }}</span>
          </div></li>
          <!--      zma交易保证金-->
        </ul>
        <div class="c-msg" style="margin-top: -1px;">
          <p v-if="msg.affimBankInfo" class="text-pre" v-html="msg.affimBankInfo"/>
        </div>
        <!--    确认银行消息-->

        <div class="c-msg mtb-20">
          <p v-if="msg.bankInfo" class="text-pre" v-html="msg.bankInfo"/>
        </div>

        <div class="footer clearfix">
          <div style="width: 34%;" class="c-box fl">
            <h3 class="c-tit">{{ $t('invoice.forOnBehalf') }}</h3>
            <h4 class="sub-tit">{{ msg.leftCompany }}</h4>
            <ul class="sign-list">
              <li style="width: 100%;">
                <p class="p1">{{ msg.leftName }}</p>
                <p class="p2"/>
                <p class="p3"/>
              </li>
            </ul>
          </div>
          <div style="width: 64%;" class="c-box fr">
            <h3 class="c-tit">{{ $t('invoice.confirmedByZMA') }}</h3>
            <h4 class="sub-tit">{{ msg.rightCompany }}</h4>
            <ul class="sign-list clearfix">
              <li class="fl">
                <p :class="msg.middleName && msg.middleName.indexOf('Name:')>-1?'tLeft':''" class="p1">{{ msg.middleName }}</p>
                <p class="p2"/>
                <p class="p3"/>
              </li>
              <li class="fr">
                <p :class="msg.rightName && msg.rightName.indexOf('Name:')>-1?'tLeft':''" class="p1">{{ msg.rightName }}</p>
                <p class="p2"/>
                <p class="p3"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="print-footer text-center">
        <div class="centerBtn btn-border-normal" @click="printVisible = false">{{ $t('btns.closePreview') }}</div>
        <div class="centerBtn btn-blue" @click="dialogConfirm">{{ $t('btns.print') }}</div>
      </div>
    </el-dialog>
    <!--      打印弹框-->

  </z-collapse>
</template>

<script>
import ZCollapse from '@/components/ZCollapse'
import mixins from '@/helper/mixins.js'
import dayjs from 'dayjs'
// import dayjs from "dayjs";
export default {
  name: 'LoanForm',
  components: {
    ZCollapse
  },
  mixins: [mixins],
  // props:['initData','comData'],
  data() {
    return {
      applicationStatus: '', // 订单状态
      msg: {},
      printVisible: false,

      currencyList: [], // 还款币种列表
      currency: 'US$', // 币种
      defaultCurrency: 'US$',
      title: '', // 发票转让标题
      transactionDate: '', // 转让时间
      exchangeRate: '', // 汇率
      exportContractAmount: '', // 出口金额
      exportContractAmountFinal: '', // 换算后出口金额
      assignedInvoiceAmount: '', // 指定的发票金额
      assignedInvoiceAmountFinal: '', // 换算后的指定金额
      zmaPurchaseAmount: '', // zma购买金额
      zmaPurchaseAmountFinal: '', // 换算后zma购买金额
      collectionAgentFee: '', // cic收取的代理费
      collectionAgentFeeFinal: '', // 换算后cic收取的代理费
      cicPayAmount: '', // cic给zma支付的费用
      cicPayAmountFinal: '', // 换算后cic给zma支付的费用
      cicPayDate: '', // cic给zma支付的时间
      zmaDiscountRate: '', // zma的净贴现率
      zmaTransactionMargin: '', // zma交易保证金
      affimBankInfo: '', // 确认银行消息
      bankInfo: '', // 银行信息

      receivedPayment: '', // 定金 为了计算指定的发票金额

      loanForm: '' // 提交的数据集合
    }
  },

  watch: {
    exchangeRate(val) {
      if (!val) {
        this.exchangeRateInput()
      }
    },
    exportContractAmount(val) {
      if (!val) {
        this.exportContractAmountInput()
      }
    },
    assignedInvoiceAmount(val) {
      if (!val) {
        this.assignedInvoiceAmountInput()
      }
    },
    zmaPurchaseAmount(val) {
      if (!val) {
        this.zmaPurchaseAmountInput()
      }
      this.calcZmaTransactionMargin()
    },
    collectionAgentFee(val) {
      if (!val) {
        this.collectionAgentFeeInput()
      }
    },
    cicPayAmount(val) {
      if (!val) {
        this.cicPayAmountInput()
      }
    }
  },
  mounted() {
    // const _this = this

    // _this.$nextTick(() => {
    //   _this.getsSysDict().then(data => {
    //     // console.log(data);
    //     _this.currencyList = data.moneyType.en
    //   })
    // })
  }, // 监听数据清空 处理联动数据
  methods: {
    handleInit(obj) {
      console.log(obj)
      this.msg = obj
      this.currencyList = obj.currencyList
      this.applicationStatus = this.msg.applicationStatus
      this.title = obj.title
      this.affimBankInfo = obj.affimBankInfo
      this.bankInfo = obj.bankInfo
     
      if (this.applicationStatus === 102 || this.applicationStatus === 1003) {
        this.initInvoice()
      }
    },

    initInvoice() {
      const _this = this
      // console.log(_this.msg);
      if (_this.msg.id) {
        _this.currency = _this.msg.currency || 'US$'
        _this.transactionDate = _this.msg.transactionDate || ''
        _this.exchangeRate = _this.msg.exchangeRate || _this.msg.id ? _this.$utils.convertNum(_this.msg.exchangeRate, 4) : ''
        _this.exportContractAmount = _this.msg.exportContractAmount || _this.msg.id ? _this.msg.exportContractAmount.toFixed(2) : ''
        _this.exportContractAmountFinal = _this.msg.exportContractAmountFinal || _this.msg.id ? _this.msg.exportContractAmountFinal.toFixed(2) : ''
        _this.assignedInvoiceAmount = _this.msg.assignedInvoiceAmount || _this.msg.id ? _this.msg.assignedInvoiceAmount.toFixed(2) : ''
        _this.assignedInvoiceAmountFinal = _this.msg.assignedInvoiceAmountFinal || _this.msg.id ? _this.msg.assignedInvoiceAmountFinal.toFixed(2) : ''
        _this.zmaPurchaseAmount = _this.msg.zmaPurchaseAmount || _this.msg.id ? _this.msg.zmaPurchaseAmount.toFixed(2) : ''
        _this.zmaPurchaseAmountFinal = _this.msg.zmaPurchaseAmountFinal || _this.msg.id ? _this.msg.zmaPurchaseAmountFinal.toFixed(2) : ''
        _this.collectionAgentFee = _this.msg.collectionAgentFee || _this.msg.id ? _this.msg.collectionAgentFee.toFixed(2) : ''
        _this.collectionAgentFeeFinal = _this.msg.collectionAgentFeeFinal || _this.msg.id ? _this.msg.collectionAgentFeeFinal.toFixed(2) : ''
        _this.cicPayAmount = _this.msg.cicPayAmount || _this.msg.id ? _this.msg.cicPayAmount.toFixed(2) : ''
        _this.cicPayAmountFinal = _this.msg.cicPayAmountFinal || _this.msg.id ? _this.msg.cicPayAmountFinal.toFixed(2) : ''
        _this.cicPayDate = _this.msg.cicPayDate || ''
        _this.zmaDiscountRate = _this.msg.zmaDiscountRate || _this.msg.id ? _this.msg.zmaDiscountRate.toFixed(3) : ''
        _this.zmaTransactionMargin = _this.msg.zmaTransactionMargin || _this.msg.id ? _this.msg.zmaTransactionMargin.toFixed(2) : ''
      } // 是否有初始值，一般是打回的情况
    },

    handleSubmit() {
      this.dealData()
      const checkResult = this.checkForm()
      if (checkResult) {
        const errorKey = checkResult
        this.$message.error(this.$t(`error.${errorKey}`))
        this.$emit('submit', false)
      } else {
        this.$emit('submit', this.loanForm)
      }
    }, // 确认提交 表单数据

    dealData() {
      const _this = this
      _this.loanForm = {}
      if (_this.applicationStatus === 102 || _this.applicationStatus === 1003) {
        if(this.msg.id){
          _this.loanForm.cicVoiceId=this.msg.id
        }
        
        _this.loanForm.title = _this.title
        _this.loanForm.transactionDateVoice = _this.transactionDate ? dayjs(_this.transactionDate).format('YYYY-MM-DD') : ''
        _this.loanForm.currencyVoice = _this.currency
        _this.loanForm.exchangeRateVoice = _this.exchangeRate
        _this.loanForm.exportContractAmount = _this.exportContractAmount
        _this.loanForm.exportContractAmountFinal = _this.exportContractAmountFinal
        _this.loanForm.assignedInvoiceAmount = _this.assignedInvoiceAmount
        _this.loanForm.assignedInvoiceAmountFinal = _this.assignedInvoiceAmountFinal
        _this.loanForm.zmaPurchaseAmount = _this.zmaPurchaseAmount
        _this.loanForm.zmaPurchaseAmountFinal = _this.zmaPurchaseAmountFinal
        _this.loanForm.collectionAgentFee = _this.collectionAgentFee
        _this.loanForm.collectionAgentFeeFinal = _this.collectionAgentFeeFinal
        _this.loanForm.cicPayAmount = _this.cicPayAmount
        _this.loanForm.cicPayAmountFinal = _this.cicPayAmountFinal
        _this.loanForm.cicPayDateVoice = _this.cicPayDate ? dayjs(_this.cicPayDate).format('YYYY-MM-DD') : ''
        _this.loanForm.zmaDiscountRate = _this.zmaDiscountRate
        _this.loanForm.zmaTransactionMargin = _this.zmaTransactionMargin
        _this.loanForm.affimBankInfo = _this.affimBankInfo
        _this.loanForm.bankInfo = _this.bankInfo
      }
      // console.log(_this.loanForm);
    }, // 整合数据

    checkForm() {
      const _this = this
      const result = Object.keys(_this.loanForm).some((val) => {
        // console.log(key+':'+val);
        if (!_this.loanForm[val]) {
          // return key;
          return true
        }
      })

      if (result) {
        return 'notEmpty'
      }

      if (!result && (_this.applicationStatus === 102 || _this.applicationStatus === 1003)) {
        if (_this.loanForm.assignedInvoiceAmount < 0 || _this.loanForm.cicPayAmount < 0 || _this.loanForm.zmaDiscountRate < 0 || _this.loanForm.zmaTransactionMargin < 0) {
          return 'notNegative' // 统一提示不能为负数
        } else {
          return ''
        }
        // if (_this.loanForm.cicPayAmount < 0) {
        //   return 'cicPayAmount_1';
        // }// CIC's Payment Amount 不能为负数
        // if (_this.loanForm.zmaDiscountRate < 0) {
        //   return 'zmaDiscountRate_1';
        // }// ZMA's Net Discount Rate 不能为负数
        // if (_this.loanForm.zmaTransactionMargin < 0) {
        //   return 'zmaTransactionMargin_1';
        // }// ZMA's Transaction Margin 不能为负数
      }
      // console.log(result);
      // console.log('1325454:'+result);
      // return result;
    }, // 校验 表单

    setBaseData(key, linkage) {
      this[key] = linkage
    }, // 接收不需要特殊处理的联动数据

    exchangeRateInput(linkage) {
      if (linkage !== undefined) {
        this.exchangeRate = linkage
      }// linkage 可能为空

      let val = ''
      const key = 'exchangeRate'
      if (this[key] > 100) {
        this[key] = '100'
        // return false;
      } else {
        this.exchangeRate = this.$utils.dealNumber(this[key], 4, 3)
      }
      val = this.exchangeRate
      this.exportContractAmountFinal = val && Number(this.exportContractAmount) ? (val * this.exportContractAmount).toFixed(2) : ''
      this.assignedInvoiceAmountFinal = val && Number(this.assignedInvoiceAmount) ? (val * this.assignedInvoiceAmount).toFixed(2) : ''

      this.zmaPurchaseAmountFinal = val && Number(this.zmaPurchaseAmount) ? (val * this.zmaPurchaseAmount).toFixed(2) : ''
      this.collectionAgentFeeFinal = val && Number(this.collectionAgentFee) ? (val * this.collectionAgentFee).toFixed(2) : ''
      this.cicPayAmountFinal = val && Number(this.cicPayAmount) ? (val * this.cicPayAmount).toFixed(2) : ''
    }, // 监听 汇率

    exportContractAmountInput(linkage) {
      // console.log(linkage);
      if (linkage !== undefined) {
        this.exportContractAmount = linkage
      }
      this.moneyInput('exportContractAmount')
      const val = this.exportContractAmount
      this.exportContractAmountFinal = this.exchangeRate && val ? (this.exchangeRate * val).toFixed(2) : ''
      this.calcAssignedInvoiceAmount()
    }, // 监听 出口金额
    invoiceNumberCoftInput(val) {
      this.msg.invoiceNumberCoft = val
    },
    assignedInvoiceAmountInput(receivedPayment, type) { // 定金
      if (receivedPayment !== undefined) {
        this.receivedPayment = receivedPayment
        this.calcAssignedInvoiceAmount()
        // this.assignedInvoiceAmount = Number(linkage).toFixed(2);
      }

      if (type != 1) {
        this.moneyInput('assignedInvoiceAmount')
      }
      const val = this.assignedInvoiceAmount
      this.assignedInvoiceAmountFinal = this.exchangeRate && val ? (this.exchangeRate * val).toFixed(2) : ''
      // this.cicPayAmount = parseFloat(val + this.collectionAgentFee).toFixed(2);
      this.calcZmaTransactionMargin()
      // this.zmaTransactionMargin = parseFloat(val - this.zmaPurchaseAmount + this.collectionAgentFee).toFixed(2);
      // this.cicPayAmountInput();
    }, // 监听 指定的发票金额

    zmaPurchaseAmountInput(linkage) {
      if (linkage !== undefined) {
        this.zmaPurchaseAmount = linkage
      }
      this.moneyInput('zmaPurchaseAmount')
      const val = this.zmaPurchaseAmount
      this.zmaPurchaseAmountFinal = this.exchangeRate && val ? (this.exchangeRate * val).toFixed(2) : ''
      this.zmaDiscountRate = val && this.cicPayAmount ? (100 - (val * 100 / this.cicPayAmount)).toFixed(3) : ''
      this.calcZmaTransactionMargin()
      // this.zmaTransactionMargin =(Number(this.assignedInvoiceAmount) - Number(val) + Number(this.collectionAgentFee)).toFixed(2);
    }, //  监听 zma购买金额

    collectionAgentFeeInput(linkage) {
      if (linkage !== undefined) {
        this.collectionAgentFee = linkage
      }
      const val = this.collectionAgentFee
      this.collectionAgentFee = this.$utils.dealNumber(val, 2, 12, 1)
      this.collectionAgentFeeFinal = this.exchangeRate && Number(val) ? (this.exchangeRate * val).toFixed(2) : ''
      // this.cicPayAmount = Number(val) ? (Number(this.assignedInvoiceAmount) + Number(val)).toFixed(2):'';
      this.calcZmaTransactionMargin()
      // this.zmaTransactionMargin = (Number(this.assignedInvoiceAmount) - Number(this.zmaPurchaseAmount) + Number(val)).toFixed(2);
      // this.cicPayAmountInput(1);
    }, //  监听 cic收取的代理费

    cicPayAmountInput(linkage) {
      if (linkage !== undefined) {
        this.cicPayAmount = linkage
      }
      const val = this.cicPayAmount
      // if(type!==1){
      //   this.moneyInput('cicPayAmount');
      // }

      this.cicPayAmountFinal = this.exchangeRate && val ? (this.exchangeRate * val).toFixed(2) : ''
      this.zmaDiscountRate = this.zmaPurchaseAmount && val ? (100 - (this.zmaPurchaseAmount * 100 / val)).toFixed(3) : ''
    }, //  监听 cic给zma支付的费用

    calcAssignedInvoiceAmount() {
      this.assignedInvoiceAmount = (Number(this.exportContractAmount) - Number(this.receivedPayment)).toFixed(2)
      this.assignedInvoiceAmountInput(undefined, 1)
    }, // 计算 指定的发票金额

    calcZmaTransactionMargin() {
      // console.log(parseFloat(this.assignedInvoiceAmount - this.zmaPurchaseAmount))
      // console.log(parseFloat(this.assignedInvoiceAmount - this.zmaPurchaseAmount) + parseFloat(this.collectionAgentFee));
      this.zmaTransactionMargin = (Number(this.assignedInvoiceAmount - this.zmaPurchaseAmount) + Number(this.collectionAgentFee)).toFixed(2)
    },

    moneyInput(key, type = 0) {
      this[key] = this.$utils.dealNumber(this[key], 2, 12, type)
    }, // 金额数据格式化

    rateInput(key) {
      if (this[key] > 100) {
        this[key] = '100'
        return false
      }
      this[key] = this.$utils.dealNumber(this[key], 3, 3)
    }, // 百分比数据 格式化

    numberBlur(key, num) {
      this[key] = this.$utils.convertNum(this[key], num)
    }, // 失去焦点 格式化数值

    printHandle() {
      console.log('打印')
      const _this = this
      if (_this.applicationStatus === 102 || _this.applicationStatus === 1003) {
        _this.dealData()
        _this.msg = Object.assign(_this.msg, _this.loanForm)
      }
      _this.printVisible = true
    },
    dialogConfirm() {
      const _this = this
      setTimeout(() => {
        _this.$print(_this.$refs.printContract)
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>

  .c-list.forfait.edit .c-textarea{
    flex-direction: column;
    padding-bottom: 5px;
    h3{
      font-size: 16px;
      color: #4E94CF;
      line-height: 22px;
      padding-bottom: 10px;
    }
  }

  .invoice-msg{
    .m-tit{
      h3{
        font-size: 16px;
        color: #4E94CF;
        font-weight: normal;
        line-height: 22px;
        padding-top: 20px;
      }
      p{
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        padding-top: 15px;
      }
    }

    .c-list li{
      > .msg{
        a{
          padding: 0;
        }
        a+a{
          padding-top: 10px;
        }
      }
    }
  }
  .c-msg{
    border: 1px solid #cccccc;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    padding: 20px 15px;
  }

</style>
